module.exports = __webpack_public_path__ + "img/钢铁行业数字化转型场景图谱.935e0f06.jpg";